///<reference path="BaseScreen.ts"/>
namespace nscs.screen {

    export class InGameUI extends BaseScreen {

        timeover_mc:Phaser.GameObjects.Container;
        newWorldScreen_mc:Phaser.GameObjects.Container;
        topUI:Phaser.GameObjects.Container;

        charName_txt:Phaser.GameObjects.Text;
        score_txt:Phaser.GameObjects.Text;
        chicks_txt:Phaser.GameObjects.Text;
        World_txt:Phaser.GameObjects.Text;
        world_txt:Phaser.GameObjects.Text;
        Time_txt:Phaser.GameObjects.Text;
        timer_txt:Phaser.GameObjects.Text;

        private bg:Phaser.GameObjects.Graphics;

        public pauseScreen:nscs.screen.PauseScreen;

        constructor(scene:Phaser.Scene) {
            super(scene);

            this.bg = new Phaser.GameObjects.Graphics(this.scene);
            this.bg.setPosition(0, 0);
            this.bg.fillStyle(0x323232, 1);
            this.bg.fillRect(0, 0, game.scale.width, game.scale.height);
            this.add(this.bg);
            this.bg.visible = false;

            //---------------------topUI---------------------//
            this.topUI = new Phaser.GameObjects.Container(this.scene, 0, 0);
            this.add(this.topUI);

            this.charName_txt = this.scene.add.text(9, 9, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 12,
                "color": "#FFFFFF",
                "align": 'left',
                "stroke":"#000000",
                "strokeThickness": 2
            });
            this.charName_txt.setOrigin(0, 0.5);
            this.topUI.add(this.charName_txt);

            this.score_txt = this.scene.add.text(9, 27, "0000000", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 12,
                "color": "#FFFFFF",
                "align": 'left',
                "stroke":"#000000",
                "strokeThickness": 2
            });
            this.score_txt.setOrigin(0, 0.5);
            this.topUI.add(this.score_txt);

            let x_txt = this.scene.add.text(170, 27, "x", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 12,
                "color": "#FFFFFF",
                "align": 'left',
                "stroke":"#000000",
                "strokeThickness": 2
            });
            x_txt.setOrigin(0.5, 0.5);
            this.topUI.add(x_txt);

            this.topUI.add(new Phaser.GameObjects.Image(this.scene, 145, 27, 'objects-atlas', 'tinyChickMC0000'));

            this.chicks_txt = this.scene.add.text(185, 27, "00", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 11,
                "color": "#FFFFFF",
                "align": 'left',
                "stroke":"#000000",
                "strokeThickness": 2
            });
            this.chicks_txt.setOrigin(0, 0.5);
            this.topUI.add(this.chicks_txt);

            this.World_txt = this.scene.add.text(305, 9, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 11,
                "color": "#FFFFFF",
                "align": 'center',
                "stroke":"#000000",
                "strokeThickness": 2
            });
            this.World_txt.setOrigin(0.5, 0.5);
            this.topUI.add(this.World_txt);
            nscs.gameplay.Gameplay.setText(this.World_txt, 'World');

            this.world_txt = this.scene.add.text(305, 27, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 11,
                "color": "#FFFFFF",
                "align": 'center',
                "stroke":"#000000",
                "strokeThickness": 2
            });
            this.world_txt.setOrigin(0.5, 0.5);
            this.topUI.add(this.world_txt);

            this.Time_txt = this.scene.add.text(470, 9, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 11,
                "color": "#FFFFFF",
                "align": 'right',
                "stroke":"#000000",
                "strokeThickness": 2
            });
            this.Time_txt.setOrigin(1, 0.5);
            this.topUI.add(this.Time_txt);
            nscs.gameplay.Gameplay.setText(this.Time_txt, 'Time');

            this.timer_txt = this.scene.add.text(470, 27, "0", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 11,
                "color": "#FFFFFF",
                "align": 'right',
                "stroke":"#000000",
                "strokeThickness": 2
            });
            this.timer_txt.setOrigin(1, 0.5);
            this.topUI.add(this.timer_txt);

            //---------------------newWorldScreen_mc---------------------//
            this.newWorldScreen_mc = new Phaser.GameObjects.Container(this.scene, 0, 0);
            this.add(this.newWorldScreen_mc);

            let World_txt:Phaser.GameObjects.Text = this.scene.add.text(game.scale.width/2, game.scale.height/2 - 25, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 15,
                "color": "#FFFFFF",
                "align": 'center'
            });
            World_txt.setOrigin(0.5, 0.5);
            this.newWorldScreen_mc.add(World_txt);
            nscs.gameplay.Gameplay.setText(World_txt, 'World');
            this.newWorldScreen_mc["World_txt"] = World_txt;
            let charIcon_mc:Phaser.GameObjects.Image = new Phaser.GameObjects.Image(this.scene, game.scale.width/2 - 35, game.scale.height/2 + 25,'ui-atlas', 'charIcon_mc'+'0000');
            this.newWorldScreen_mc['charIcon_mc'] = charIcon_mc;
            this.newWorldScreen_mc.add(charIcon_mc);
            this.gotoAndStop_charIcon_mc(nscs.scene.MainScene.instance.gameplay.character);

            this.newWorldScreen_mc.add(this.scene.add.text(game.scale.width/2, game.scale.height/2 + 25, "x", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 18,
                "color": "#FFFFFF",
                "align": 'center'
            }).setOrigin(0.5, 0.5));
            let lives_txt:Phaser.GameObjects.Text = this.scene.add.text(game.scale.width/2 + 20, game.scale.height/2 + 25, "0", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 18,
                "color": "#FFFFFF",
                "align": 'left'
            });
            lives_txt.setOrigin(0, 0.5);
            this.newWorldScreen_mc.add(lives_txt);
            this.newWorldScreen_mc["lives_txt"] = lives_txt;

            this.newWorldScreen_mc.visible=false;

            //pause
            this.pauseScreen = new nscs.screen.PauseScreen(this.scene);
            this.add(this.pauseScreen);

            //---------------------timeover_mc---------------------//
            this.timeover_mc = new Phaser.GameObjects.Container(this.scene, 0, 0);
            this.add(this.timeover_mc);
            let bg = new Phaser.GameObjects.Graphics(this.scene);
            bg.setPosition(0, 0);
            bg.fillStyle(0x000000, 0.4);
            bg.fillRect(0, 0, game.scale.width, game.scale.height);
            this.timeover_mc.add(bg);
            let TimeOver_txt:Phaser.GameObjects.Text = this.scene.add.text(game.scale.width/2, game.scale.height/2, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 33,
                "color": "#FFFFFF",
                "align": 'center'
            });
            TimeOver_txt.setOrigin(0.5, 0.5);
            TimeOver_txt.setStroke('#000000', 3);
            this.timeover_mc.add(TimeOver_txt);
            nscs.gameplay.Gameplay.setText(TimeOver_txt, 'TimeOver');
            this.timeover_mc['TimeOver_txt'] = TimeOver_txt;

            this.timeover_mc.visible = false;
        }

        public setScore(scores:number):void {
            this.score_txt.setText(nscs.util.Functions.pad(scores, 7, 0));
        }

        public setChicks(chicks:number):void {
            this.chicks_txt.setText(nscs.util.Functions.pad(chicks, 2, 0));
        }

        public setCharacterName(characterType:string, lives:number):void {
            nscs.gameplay.Gameplay.setText(this.charName_txt, characterType);
            this.charName_txt.setText(this.charName_txt.text + " x " + lives);
        }

        public showNewWorldScreen():InGameUI {
            nscs.gameplay.Gameplay.setText(this.newWorldScreen_mc["World_txt"], 'World');
            nscs.util.Functions.updateTextFieldPosition(this.newWorldScreen_mc["World_txt"], this.newWorldScreen_mc["World_txt"].text + " " + this.world_txt.text);
            nscs.util.Functions.updateTextFieldPosition(this.newWorldScreen_mc["lives_txt"], this.charName_txt.text.split(" x ")[1]);
            this.newWorldScreen_mc.visible = true;
            this.bg.visible = true;
            return this;
        }

        public hideNewWorldScreen():InGameUI {
            this.newWorldScreen_mc.visible = false;
            this.bg.visible = false;
            return this;
        }

        public gotoAndStop_charIcon_mc(label:string):InGameUI {
            let labels_map = {
                'chickette':'charIcon_mc'+'0000',
                'nugget':'charIcon_mc'+'0009',
                'pam':'charIcon_mc'+'0019'
            };
            this.newWorldScreen_mc['charIcon_mc'].setFrame(labels_map[label]);
            return this;
        }

        private speechDialog:Phaser.GameObjects.Container = null;
        public showSpeechDialog(x:number, textContent:string):void {
            this.hideSpeechDialog();

            this.speechDialog = new Phaser.GameObjects.Container(this.scene, game.scale.width/2, 136);
            this.add(this.speechDialog);

            this.speechDialog['startX'] = x;

            let bubblex_mc:Phaser.GameObjects.Image = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'bubblex_mc'+'0000');
            bubblex_mc.setOrigin(0.5, 1);
            this.speechDialog.add(bubblex_mc);
            this.speechDialog["bubblex_mc"] = bubblex_mc;

            let mouthPiece_mc:Phaser.GameObjects.Image = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'mouthPiece_mc'+'0000');
            mouthPiece_mc.setOrigin(0.5, 1);
            this.speechDialog.add(mouthPiece_mc);
            this.speechDialog["mouthPiece_mc"] = mouthPiece_mc;

            let barMask = new Phaser.GameObjects.Graphics(this.scene);
            let p = this.scene.cameras.main.getWorldPoint(this.speechDialog.x, this.speechDialog.y);
            barMask.setPosition(p.x, p.y);
            barMask.fillStyle(0xFFFFFF, 1);
            barMask.fillRect(-400/2, -mouthPiece_mc.height, 400, mouthPiece_mc.height);
            mouthPiece_mc.setMask(barMask.createGeometryMask());
            mouthPiece_mc['barMask'] = barMask;
            this.prevBarMaskPosX = barMask.x;

            this.speechDialog.alpha = 0.5;
            barMask.scale = this.speechDialog.scale = 0;
            this.scene.tweens.add({
                targets: [this.speechDialog, barMask],
                duration: 500,
                scale:1,
                alpha:1,
                ease:Phaser.Math.Easing.Back.Out
            });
            this.add(this.speechDialog);

            let tf:Phaser.GameObjects.Text = this.scene.add.text(-222, -120, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 11,
                "color": "#000000",
                "align": 'left'
            });
            tf.setOrigin(0, 0);
            tf.setWordWrapWidth(455);
            this.speechDialog.add(tf);
            let textTyper:nscs.util.TextTyper = new nscs.util.TextTyper(this.scene, tf, null);
            textTyper.typeText(textContent);
            this.speechDialog['textTyper'] = textTyper;
        }

        private prevBarMaskPosX:number;
        public updateSpeechDialog(x:number):void {
            let p = this.scene.cameras.main.getWorldPoint(this.speechDialog.x, this.speechDialog.y);
            this.speechDialog["mouthPiece_mc"]['barMask'].setPosition(this.prevBarMaskPosX + (p.x-this.prevBarMaskPosX)*2 , p.y);
            this.prevBarMaskPosX = p.x;
            this.speechDialog["mouthPiece_mc"].x = this.speechDialog['startX'] - x;
        }

        public hideSpeechDialog():void {
            if (this.speechDialog) {
                (this.speechDialog['textTyper'] as nscs.util.TextTyper).stop();
                this.remove(this.speechDialog);
                this.speechDialog = null;
            }
        }

        public tweenTextField(txt:Phaser.GameObjects.Text, to:number, duration:number, render = null):void {
            txt['-to-'] = parseInt(txt.text);
            if (isNaN(txt['-to-'])) txt['-to-'] = 0;

            if (!render) render = () => {
                nscs.util.Functions.updateTextFieldPosition(txt, String(Math.round(txt['-to-'])));
            };

            let ticker:number = 0;
            this.scene.tweens.add({
                targets: txt,
                '-to-': to,
                duration: duration,
                ease: Phaser.Math.Easing.Linear,
                onComplete: render,
                onUpdate: ()=>{
                    if (ticker++ % 2 == 0) nscs.sound.SoundManager.getInstance().playSound('tickerSND');
                    render();
                }
            });
        }

        public tweenScore(to:number, duration:number):void {
            this.tweenTextField(this.score_txt, to, duration, ()=>{
                this.setScore(Math.round(this.score_txt['-to-']));
            });
        }

        public tweenTimer(to:number, duration:number):void {
            this.tweenTextField(this.timer_txt, to, duration);
        }
    }
}
